export default "__VITE_ASSET__437d7782__"